import { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useLang } from '@/hooks/useLang';
import { localizePath } from '@/lib/localizePath';

/**
 * Enveloppe le <Link> de react-router-dom.
 * Le `to` est toujours exprimé en chemin français (ex: '/produits') ;
 * le composant applique automatiquement le préfixe de langue actif.
 */
const LocalizedLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const lang = useLang();
    const localizedTo = typeof to === 'string' ? localizePath(to, lang) : to;
    return <Link ref={ref} to={localizedTo} {...props} />;
  }
);

LocalizedLink.displayName = 'LocalizedLink';

export default LocalizedLink;
